var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8979 10.1689C14.6272 9.99673 12.0749 12.275 11.5121 15.8408C11.046 18.7937 11.8723 22.3919 12.5792 22.573C12.879 22.6498 13.6004 22.0959 14.1253 21.599C14.224 21.5056 14.3732 21.4899 14.4889 21.5609C15.3071 22.0631 16.2335 22.4406 17.2548 22.4943C20.6125 22.6711 23.5881 20.0331 23.764 16.6622C23.9399 13.2912 21.2556 10.3457 17.8979 10.1689ZM12.4209 27.2878C12.2943 27.1978 12.1198 27.2222 12.0137 27.3358C10.5952 28.8546 6.96485 29.9199 6.79856 27.847C6.79856 26.2229 6.43518 24.8544 6.03509 23.3475C5.54507 21.502 5 19.4491 5 16.4655C5 9.35068 10.8127 4 17.7046 4C24.5964 4 30 9.61192 30 16.5346C30 23.4573 24.4245 28.931 17.7698 28.931C15.4089 28.931 14.2632 28.5972 12.4209 27.2878Z",
    fill: "#C6CBCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMax);
export default __webpack_public_path__ + "static/media/max.8ba8cb3f2cf120ff83d930c4559d77a4.svg";
export { ForwardRef as ReactComponent };